<template>
    <div class="menu-dropdown" ref="menuDropdown">
        <div class="arrow-up-set"></div>
        <div class="menu-dropdown-content">
            <div class="padding-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import {setTimeout} from 'timers';

    export default {
        name: "Dropdown",
        data() {
            return {
                DataTopPos: 0,
                DataLeftPos: 0
            }
        },
        methods: {
            getElementSetNew: function(){
                if (this.$refs.menuDropdown.closest('.dropdown-setter') != null && this.$refs.menuDropdown && typeof this.$refs.menuDropdown.closest('.dropdown-setter') !== 'undefined') {
                    
                }
            },
            
            
            getElementSet: function () {
                if (this.$refs.menuDropdown.closest('.dropdown-setter') != null && this.$refs.menuDropdown && typeof this.$refs.menuDropdown.closest('.dropdown-setter') !== 'undefined') {

                    let wrapElem = this.$refs.menuDropdown.closest('.dropdown-setter'),
                        clickButton = wrapElem.querySelector('.vs-con-dropdown');
                    //Getting data value    
                    let dataElement = document.querySelectorAll('.dropdown-setter').forEach((e, n) => {
                        document.querySelectorAll('.vs-con-dropdown[data-getter=' + e.dataset.setter + ']').forEach((f, m) => {

                            let srcElem = e.querySelector('.menu-dropdown');
                            srcElem.dataset.getter = e.dataset.setter;
                            //Getting each click button element as global.

                            // f == "each vs-con-dropdown" == each more icon button 
                            let initPos = f.getBoundingClientRect();
                            // console.log(f, "f is here", initPos)
                            //Getting positions
                            let leftPos = initPos.left;
                            //Updating data properties
                            this.DataTopPos = (initPos.top) + (initPos.height);
                            this.DataLeftPos = (initPos.left) - 23;
                            //Setting positions

                            srcElem.style.top = this.DataTopPos + "px";
                            srcElem.style.left = this.DataLeftPos + "px";
                            if ((leftPos + srcElem.offsetWidth) > screen.width) {
                                //srcElem.classList.add('open-d-right');
                                //srcElem.style.left = (leftPos - srcElem.offsetWidth) + "px";
                                srcElem.classList.add('open-d-right');
                                srcElem.style.left = (leftPos - (srcElem.offsetWidth / 2)) + "px";
                            }

                            //Click Function
                            try {
                                f.addEventListener('click', function (e) {
                                    e.stopPropagation();
                                    if (document.querySelector('.report-header-options.r-open') != undefined && document.querySelector('.report-header-options.r-open') != null) {
                                        document.querySelector('.report-header-options.r-open').classList.remove('r-open');
                                    }
                                    document.querySelectorAll('.menu-dropdown').forEach(function (node) {
                                        node.classList.remove('open-d')
                                    });

                                    srcElem.classList.toggle('open-d');
                                    if (srcElem.classList.contains('open-d')) {
                                        if (srcElem.querySelector('input') != undefined && srcElem.querySelector('input') != null) {
                                            srcElem.querySelector('input').focus();
                                        }
                                    }


                                });
                            } catch (e) {
                            }
                            document.body.prepend(srcElem);
                        });
                    });

                    //outside click
                    document.body.addEventListener('click', function (e) {
                        if (e.srcElement === "text" || e.srcElement.closest('.menu-dropdown')) {
                            // Not  using
                        } else {
                            document.querySelectorAll('.menu-dropdown').forEach(function (node) {
                                node.classList.remove('open-d')
                            });
                        }
                    });
                    //Adding source element to body
                    // var cloneDropdown = srcElem.cloneNode(true);
                    // cloneDropdown.classList.add('clone-dropdown');

                    window.addEventListener('resize', function () {
                        document.querySelectorAll('.menu-dropdown').forEach(function (node) {
                            node.classList.remove('open-d');
                        });

                    })
                }
            },

            setDropdownPos: function () {
                let dataElement = document.querySelectorAll('.dropdown-setter').forEach((e, n) => {
                    document.querySelectorAll('.vs-con-dropdown[data-getter=' + e.dataset.setter + ']').forEach((f, m) => {
                        let srcElem = document.querySelector('.menu-dropdown[data-getter=' + e.dataset.setter + ']');
                        //Getting each click button element as global.
                        // f == "each vs-con-dropdown" == each more icon button
                        let initPos = f.getBoundingClientRect();
                        // console.log(f, "f is here", initPos)
                        //Getting positions
                        let leftPos = initPos.left;
                        //Updating data properties
                        this.DataTopPos = (initPos.top) + (initPos.height);
                        this.DataLeftPos = (initPos.left) - 23;
                        //Setting positions

                        console.log(this.DataLeftPos, "DataLeftPos");

                        srcElem.style.top = this.DataTopPos + "px";
                        srcElem.style.left = this.DataLeftPos + "px";
                        if ((leftPos + srcElem.offsetWidth) > screen.width) {
                            //srcElem.classList.add('open-d-right');
                            //srcElem.style.left = (leftPos - srcElem.offsetWidth) + "px";
                            srcElem.classList.add('open-d-right');
                            srcElem.style.left = (leftPos - (srcElem.offsetWidth / 2)) + "px";
                        }
                    });
                });
            },
            
            openDropdown: function(){
                document.querySelectorAll('.vs-con-dropdown').forEach(function(e){
                    e.addEventListener('click', function(f){
                        f.preventDefault();
                        document.querySelectorAll('.menu-dropdown').forEach(function(k){
                            k.classList.remove('open-d');
                        })
                        e.nextSibling.classList.add('open-d');
                    })
                });
                
                
                /* outside click */
                    document.body.addEventListener('click', function (e) {
                        if(e.srcElement.closest('.dropdown-setter')){
                           
                        }
                        else{
                            document.querySelectorAll('.menu-dropdown').forEach(function (node) {
                                node.classList.remove('open-d')
                            });
                        }
                        
                    });
            }
        },
        updated() {
            setTimeout(() => {
                // this.getElementSet();
                
                // this.getElementSetNew();
                this.openDropdown();
            }, 1000);
        },
        mounted() {
            setTimeout(() => {
                let el = document.querySelector('.qtime-h-scroll');
                this.openDropdown();
                if (typeof el != 'undefined' && el != null) {
                    el.addEventListener('scroll', () => {
                        // this.setDropdownPos();
                        
                        // this.getElementSetNew();
                    })
                }
            }, 1000)
        }
    }
</script>
<style>
    .menu-dropdown {
        position: fixed;
        top: 0;
        left: 0;
        width: 250px;

        height: auto;
        background: #ffffff;
        box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.1);
        max-height: 0;
        overflow: hidden;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        z-index: 100;
        transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
        transform: translateY(10px);
        -webkit-transform: translateY(10px);
        -moz-transform: translateY(10px);
    }
    
    .left-pos-cell .menu-dropdown{
        left: 50px;
    }
    
    .right-pos-cell .menu-dropdown{
        left: auto;
        left: unset;
        right: 20px;
    }
    /* new */
     .menu-dropdown {
        position: absolute;
        top: 30px;
     }
    
    .date-dropdown-box {
        width: 315px;
        padding: 0;
        box-shadow: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
    }

    .date-dropdown-box .padding-content {
        padding: 0 !important;
    }

    .date-dropdown-box .datepicker-container {
        border-left: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        border-bottom: 1px solid #e0e0e0;
    }

    .menu-dropdown-content {
        max-height: 0;
        overflow: hidden;
    }

    .menu-dropdown-content .padding-content {
        padding: 15px 20px 15px 20px;
    }

    .menu-dropdown.open-d {
        overflow: visible;
        max-height: 400px;
        transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
    }

    .menu-dropdown.open-d .menu-dropdown-content {
        max-height: 400px;
        transition: all 0.3s ease;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        transform: translateY(0);
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        transition: all 0.2s ease;
        -webkit-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
    }

    .menu-dropdown li {
        /* padding: 10px 0; */
    }

    .menu-dropdown li:first-child {
        /* padding: 0 0; */
    }

    .arrow-up-set {
        position: absolute;
        width: 20px;
        height: 20px;
        background: #ffffff;
        transform: rotate(40deg) translateY(-6px);
        -webkit-transform: rotate(40deg) translateY(-6px);
        -moz-transform: rotate(40deg) translateY(-6px);
        left: 20px;
        top: 0;
    }

    .open-d-right .arrow-up-set {
        left: auto;
        right: 20px;
    }
    
    .right-pos-cell  .menu-dropdown  .arrow-up-set{
         right: 20px;
         left: auto;
         left: unset;
     }
</style>
